import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { BLOG_LIST } from "@/data/blog";

const BLOG_JSONLD = [{
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "Ecroply AI Blog",
  url: "https://ecroplyai.in/blog",
}];

export default function Blog() {
  return (
    <>
      <Seo
        title="Ecroply AI Blog – E-commerce Seller Guides"
        description="Practical guides for Amazon, Flipkart, Meesho and Shopsy sellers: cropping shipping labels and using the AI listing tools."
        path="/blog"
        jsonLd={BLOG_JSONLD}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }]}
      />

      <section className="relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 grid-dots opacity-10" />
        <div className="absolute -top-24 right-0 w-[28rem] h-[28rem] bg-blue-600/20 rounded-full blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
          <span className="inline-flex items-center gap-2 bg-blue-500/20 text-blue-200 border border-blue-400/30 rounded-full px-4 py-1.5 text-sm font-medium mb-6">
            <BookOpen className="w-4 h-4" /> Guides
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">Ecroply AI Blog</h1>
          <p className="mt-4 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
            Practical, specific guides for sellers on Amazon, Flipkart, Meesho and Shopsy — cropping shipping labels for each marketplace, and getting a usable first draft out of the AI listing tools.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {BLOG_LIST.map((post) => (
            <Link key={post.slug} to={post.path} data-testid={`blog-card-${post.slug}`}
              className="group bg-white border border-slate-200 hover:border-blue-400 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/5 hover:-translate-y-1 flex flex-col">
              {post.hero && (
                <div className="aspect-[3/2] overflow-hidden bg-slate-900">
                  <img src={post.hero} alt={post.heroAlt} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
                <h2 className="font-heading font-bold text-lg text-slate-900 leading-snug">{post.h1}</h2>
                <p className="mt-2 text-sm text-slate-600 flex-1">{post.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600">
                  Read guide <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
